import moment from "moment-timezone";

export enum SnoozeOptions {
  LaterToday = 'later_today',
  Tomorrow = 'tomorrow',
  NextMonday = 'next_monday',
  InOneWeek = 'in_one_week',
  InOneMonth = 'in_one_month',
  Custom = 'custom',
}

export const defaultSnoozeTime = {hour: 9, minute: 0, second: 0, millisecond: 0};

export const getSnoozeOptions = () => {
  const today = moment();
  return [
    {
      label: 'Later today',
      description: 'In 3 hours',
      value: SnoozeOptions.LaterToday,
    },
    {
      label: 'Tomorrow',
      description: today.add(1, 'day').set(defaultSnoozeTime).format('ddd ha'),
      value: SnoozeOptions.Tomorrow,
    },
    {
      label: 'Monday',
      description: today.startOf('isoWeek').add(1, 'week').day('monday').set(defaultSnoozeTime).format('ddd ha'),
      value: SnoozeOptions.NextMonday,
    },
    {
      label: 'One week',
      description: today.add(1, 'week').set(defaultSnoozeTime).format('MMM D'),
      value: SnoozeOptions.InOneWeek,
    },
    {
      label: 'One month',
      description: today.add(1, 'month').set(defaultSnoozeTime).format('MMM D'),
      value: SnoozeOptions.InOneMonth,
    },
    {
      label: 'Custom',
      description: '',
      value: SnoozeOptions.Custom,
    },
  ];
};
